module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-400-regular-italic-9dd18cfbe059ea6e53c40bd292aba5e5.woff2";